import { Box } from "@mui/material";
import { senecPrimaryColors, senecSecondaryColors } from "src/styles/ekp-theme/senecEkpTheme";

export interface FlowerItemProps {
    title: string;
    value: string;
    color: string;
    legend: string;
    errorMessage?: string;
    inactive?: boolean;
}

export const FlowerItem = ({ title, value, color, errorMessage, inactive, legend }: FlowerItemProps) => {
    return (
        <Box
            data-testid="flower-item"
            sx={{
                aspectRatio: "1",
                backgroundColor: color,
                borderColor: senecSecondaryColors.neutralGray20,
                borderRadius: "50%",
                borderStyle: "solid",
                borderWidth: 0.5,
                color: senecPrimaryColors.white,
                fontFamily: "Mark Pro, sans-serif",
                textAlign: "center",
                width: { xsMobile: "95px", xs: "120px" },
                opacity: inactive ? 0.2 : 1,
            }}
        >
            <Box
                sx={{
                    fontSize: 12,
                    fontWeight: 500,
                    marginTop: { xsMobile: "10px", xs: "16px" },
                }}
            >
                {title}
            </Box>
            {!errorMessage && (
                <Box
                    sx={{
                        position: "absolute",
                        fontSize: 24,
                        fontWeight: 400,
                        lineHeight: 1,
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                >
                    {value}
                </Box>
            )}
            {errorMessage && (
                <Box
                    sx={{
                        position: "absolute",
                        fontSize: 12,
                        width: "100%",
                        fontWeight: 500,
                        lineHeight: 1.25,
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                >
                    {errorMessage}
                </Box>
            )}
            {value?.includes("/") && (
                <Box
                    sx={{
                        position: "absolute",
                        fontSize: 12,
                        width: "100%",
                        fontWeight: 500,
                        bottom: 0,
                        marginBottom: { xsMobile: "16px", xs: "26px" },
                    }}
                >
                    {legend}
                </Box>
            )}
        </Box>
    );
};
